<template>
  <div
    role="status"
    aria-live="polite"
    class="flex h-full flex-col items-center justify-center gap-3 py-12"
  >
    <span
      class="size-10 animate-spin rounded-full border-[3px] border-blue-100 border-t-blue-600 motion-reduce:animate-[spin_1.5s_linear_infinite]"
    />
    <span class="animate-pulse text-sm font-medium text-gray-500 motion-reduce:animate-none">
      {{ $t('common.loading') }}
    </span>
  </div>
</template>
